import React from "react";
import { useTranslation } from "react-i18next";
import "../printing/PrintingDisclaimerModal.css";

const ProofreadingConfirmModal = ({ isOpen, onClose, onProceed }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="printing-disclaimer-modal-overlay">
      <div className="printing-disclaimer-modal">
        <div className="printing-disclaimer-header">
          <h3>{t("proofreading.confirm_title")}</h3>
        </div>

        <div className="printing-disclaimer-content">
          <p className="disclaimer-intro">
            {t("proofreading.confirm_no_estimation")}
          </p>
        </div>

        <div className="printing-disclaimer-buttons">
          <button className="btn-modify" onClick={onClose}>
            {t("proofreading.confirm_go_back")}
          </button>
          <button className="btn-proceed" onClick={onProceed}>
            {t("proofreading.confirm_proceed")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProofreadingConfirmModal;
